import { FC } from 'react';
import { createPortal } from 'react-dom';
import { Button } from 'src/Components';
import { ScanFileType, useScan } from './';
import { ReactComponent as ScanIcon } from './assets/skan.svg';

interface IScanProps {
	enable?: boolean;
	setBlobFunction: (file: ScanFileType, count: number) => void;
}

const Scan: FC<IScanProps> = (props) => {
	const { enable = true, setBlobFunction } = props;

	const { isWait, available, showModal, setShowModal, renderModal } = useScan(
		enable,
		setBlobFunction,
	);

	const renderBtn = () => {
		return (
			<Button
				style={{ padding: '2px 12px 2px 6px' }}
				disable={!available}
				isWait={isWait}
				onClick={() => {
					return setShowModal(true);
				}}
			>
				<ScanIcon width={24} height={24} />
				Сканировать
			</Button>
		);
	};

	return (
		<>
			{renderBtn()}
			{showModal && createPortal(renderModal(), document.body)}
		</>
	);
};

export default Scan;
